export default Object.freeze({
  400: 'candidateExport.errors.badRequest',
  404: 'candidateExport.errors.noData',
  422: 'candidateExport.errors.validationFailed',
})
